const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/therapists/index.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
export const Route = createFileRoute("/dashboard/admin/therapists/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type StatusFilter = "pending" | "approved" | "rejected";